import React, { Component } from 'react';
import {Table} from 'reactstrap';
import {Link} from  'react-router-dom';
import { Button } from '../../../components';
import {connect} from 'react-redux';
import {getAttributes} from '../../../actions/attributeActions';
import ReactPaginate from 'react-paginate';
class Attributes extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      attrLoading:false,
      isMounted: false,
      skip: 0,
      limit:12
     }

  }


     componentDidMount = () => {
      this.setState({ isMounted: true }, () => {
        if (this.state.isMounted) {
          this.setState({ isMounted: false });
      {this.props.onGetAttributes(this.state.skip,this.state.limit);}
    }
    });
     }

     handlePageClick = (data) => {
      let selected = data.selected;
      let skip = selected * this.state.limit
      this.setState({skip: skip});
      this.props.onGetAttributes(skip,this.state.limit);
    }
    
     getLoder = () => {
      let classes = "bt-loader ";
      classes += this.props.attrLoading ? 'bt-show' : 'bt-hide';
      return classes;
    }

    render() { 
      const {attributes} = this.props;
        return (
        <div>
            <div className="content">
            <div className={this.getLoder()}></div>
            <div className="table-product-wrapper">
                  <Table>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>NAME</th>
                        <th>CODE</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                    {attributes.length>0 ? attributes.map((attribute,index) => (
                        <tr key={attribute.id}>
                        <td>{index+1}</td>
                        <td>{attribute.name}</td>
                        <td>{attribute.code}</td>
                        <td>
                          <div className="group-action text-right pr-10">
                            <Link className="btn" to={`/admin/edit-attribute/${attribute.id}`}>
                              <i className="ico icon-edit" />
                            </Link>
                            {/* <button className="btn">
                              <i className="ico icon-delete" />
                            </button> */}
                          </div>
                        </td>
                      </tr>    
                    )):<tr><td colSpan={'4'}>No data found</td></tr>}
                        
                     
                    </tbody>
                  </Table>
                </div>
                <Button className="fixed-yellow"  onClick={() => this.props.history.push("/admin/add-attribute")}>Add</Button>
                <div className="pagination-wrapper">
        <ReactPaginate previousLabel={<i className="fas fa-angle-left"></i>}
        nextLabel={<i className="fas fa-angle-right"></i>}
        pageLinkClassName={"page-link"}
        breakClassName={"break-me"}
        pageCount={Math.ceil(this.props.count/this.state.limit)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        activeClassName={"active"} />
        </div>
           </div>    
        </div>  );
    }
}


Attributes.defaultProps = {
  attributes : []
}
 
const mapStateToProps = (state) =>({
  attrLoading:state.attributeReducer.attrLoading,
  attributes: state.attributeReducer.attributes,
  message:state.attributeReducer.message,
  count:state.attributeReducer.count,
  popup:state.attributeReducer.popup
});

const mapDispatchToProps = (dispatch) =>({
  onGetAttributes:(skip,take)=>{
    dispatch(getAttributes(skip,take))
  }
})
 
export default connect(mapStateToProps,mapDispatchToProps)(Attributes);